import React from 'react';
import RenderIf from 'components/RenderIf/RenderIf';
import { useParams } from 'react-router-dom';
import { useGetDealById } from 'views/Deals/hooks/useGetDealById';
import useAuthContext from 'contexts/AuthContext';
import { useGetBackOfEnvelope } from 'views/DealDashboard/BOE/hooks/useGetBOE';
import { ProFormaWizardProvider, useProFormaWizard } from './context/ProFormaWizardProvider';
import ProFormaWizardStepper from './components/ProFormaWizardStepper/ProFormaWizardStepper';
import ProFormaWizardStepOne from './components/ProFormaWizardStepOne/ProFormaWizardStepOne';
import ProFormaWizardStepTwo from './components/ProFormaWizardStepTwo/ProFormaWizardStepTwo';
import ProFormaWizardStepThree from './components/ProFormaWizardStepThree/ProFormaWizardStepThree';
import { PRO_FORMA_WIZARD_STEPS } from './constants';

const ProFormaWizardContent = () => {
    const { currentStep, proForma } = useProFormaWizard();
    const { dealId } = useParams<{ dealId: string }>();
    const { selectedOrganizationId } = useAuthContext();

    const { data: deal } = useGetDealById({
        orgId: selectedOrganizationId!,
        dealId: Number(dealId),
        shouldFetch: !!Number(dealId),
    });

    const { data: boeScenario } = useGetBackOfEnvelope({
        orgId: selectedOrganizationId!,
        scenarioId: Number(proForma?.boeScenario?.id || 0),
        enabled: !!selectedOrganizationId && !!proForma?.boeScenario?.id,
    });

    return (
        <div>
            <ProFormaWizardStepper boeScenario={boeScenario} />

            <RenderIf isTrue={currentStep === PRO_FORMA_WIZARD_STEPS.STEP_1}>
                <ProFormaWizardStepOne deal={deal} />
            </RenderIf>

            <RenderIf isTrue={currentStep === PRO_FORMA_WIZARD_STEPS.STEP_2}>
                <ProFormaWizardStepTwo deal={deal} boeScenario={boeScenario} />
            </RenderIf>

            <RenderIf isTrue={currentStep === PRO_FORMA_WIZARD_STEPS.STEP_3}>
                <ProFormaWizardStepThree boeScenario={boeScenario} />
            </RenderIf>

        </div>
    );
};

const ProFormaWizard = () => (
    <ProFormaWizardProvider>
        <ProFormaWizardContent />
    </ProFormaWizardProvider>
);

export default ProFormaWizard;
